// PieChart.tsx
import { FC } from 'react'
import { Pie } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions,
} from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

type Props = {
  data: any
  height?: number
}

const options: ChartOptions<'pie'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { position: 'bottom' } },
}

const NewPieChart: FC<Props> = ({ data, height = 230 }) => {
  return (
    <div style={{ height }}>
      <Pie data={data} options={options} />
    </div>
  )
}

export default NewPieChart
